import React from 'react';
import { CalculationContext } from '../../../../context/CalculationContext';

const useAdvancedSettings = (translations) => {
    const calculationContext = React.useContext(CalculationContext);

    const percentageDivisionFields = [
        {
            // Heating Division Percentage
            value: calculationContext.heatingDivisionPercentage,
            label: translations.energyDivisionHeatingLabel,
            assistiveText: translations.energyDivisionHeatingAssistiveText,
            onChange: calculationContext.setHeatingDivisionPercentage,
            invalid: calculationContext.invalidDivisionPercent,
            locked: calculationContext.heatingDivisionLocked,
            setLocked: calculationContext.setHeatingDivisionLocked
        },
        {
            // Cooling Division Percentage
            value: calculationContext.coolingDivisionPercentage,
            label: translations.energyDivisionCoolingLabel,
            assistiveText: translations.energyDivisionCoolingAssistiveText,
            onChange: calculationContext.setCoolingDivisionPercentage,
            invalid: calculationContext.invalidDivisionPercent,
            locked: calculationContext.coolingDivisionLocked,
            setLocked: calculationContext.setCoolingDivisionLocked
        },
        {
            // Domestic Hot Water Division Percentage
            value: calculationContext.domesticHotWaterDivisionPercentage,
            label: translations.energyDivisionHotWaterLabel,
            assistiveText: translations.energyDivisionHotWaterAssistiveText,
            onChange: calculationContext.setDomesticHotWaterDivisionPercentage,
            invalid: calculationContext.invalidDivisionPercent,
            locked: calculationContext.hotWaterDivisionLocked,
            setLocked: calculationContext.setHotWaterDivisionLocked
        },
        {
            // Building Electricity Division Percentage
            value: calculationContext.buildingElectricityDivisionPercentage,
            label: translations.energyDivisionBuildingElectricityLabel,
            assistiveText: translations.energyDivisionBuildingElectricityAssistiveText,
            onChange: calculationContext.setBuildingElectricityDivisionPercentage,
            invalid: calculationContext.invalidDivisionPercent,
            locked: calculationContext.buildingElectricityDivisionLocked,
            setLocked: calculationContext.setBuildingElectricityDivisionLocked
        },
        {
            // Business Electricity Division Percentage
            value: calculationContext.businessElectricityDivisionPercentage,
            label: translations.energyDivisionBusinessElectricityLabel,
            assistiveText: translations.energyDivisionBusinessElectricityAssistiveText,
            onChange: calculationContext.setBusinessElectricityDivisionPercentage, // TODO
            invalid: calculationContext.invalidDivisionPercent,
            locked: calculationContext.businessElectricityDivisionLocked,
            setLocked: calculationContext.setBusinessElectricityDivisionLocked
        }
    ];

    const costFields = [
        {
            label: translations.electricityLabel,
            assistiveText: translations.electricityAssistiveText,
            onChange: calculationContext.setEnergyCostElectricity,
            value: calculationContext.energyCostElectricity,
            suffix: `${calculationContext.currency}/${translations.locKwhLabel}`
        },
        {
            label: translations.gasLabel,
            assistiveText: translations.gasAssistiveText,
            onChange: calculationContext.setEnergyCostGas,
            value: calculationContext.energyCostGas,
            suffix: `${calculationContext.currency}/${translations.locKwhLabel}`
        },
        {
            label: translations.oilLabel,
            assistiveText: translations.oilAssistiveText,
            onChange: calculationContext.setEnergyCostOil,
            value: calculationContext.energyCostOil,
            suffix: `${calculationContext.currency}/${translations.locKwhLabel}`
        },
        {
            label: translations.districtHeatingLabel,
            assistiveText: translations.districtHeatingAssistiveText,
            onChange: calculationContext.setEnergyCostDistrictHeating,
            value: calculationContext.energyCostDistrictHeating,
            suffix: `${calculationContext.currency}/${translations.locKwhLabel}`
        },
        {
            label: translations.districtCoolingLabel,
            assistiveText: translations.districtCoolingAssistiveText,
            onChange: calculationContext.setEnergyCostDistrictCooling,
            value: calculationContext.energyCostDistrictCooling,
            suffix: `${calculationContext.currency}/${translations.locKwhLabel}`
        }
    ];

    const productionEfficiencyFields = [
        {
            label: translations.heatingLabel,
            assistiveText: translations.heatingAssistiveText,
            onChange: calculationContext.setHeatingProductionEfficiency,
            value: calculationContext.heatingProductionEfficiency,
            suffix: translations.kilowattPerKilowatt
        },
        {
            label: translations.coolingLabel,
            assistiveText: translations.coolingAssistiveText,
            onChange: calculationContext.setCoolingProductionEfficiency,
            value: calculationContext.coolingProductionEfficiency,
            suffix: translations.kilowattPerKilowatt
        },
        {
            label: translations.domesticHotWaterLabel,
            assistiveText: translations.domesticHotWaterAssistiveText,
            onChange: calculationContext.setHotWaterProductionEfficiency,
            value: calculationContext.hotwaterProductionEfficiency,
            suffix: translations.kilowattPerKilowatt
        }
    ];

    const ghgFields = [
        {
            label: translations.electricityLabel,
            assistiveText: translations.electricityAssistiveText,
            onChange: calculationContext.setGHGCo2Electricity,
            value: calculationContext.GreenhouseGasCo2Electricity,
            suffix: translations.kCo2eLabel
        },
        {
            label: translations.gasLabel,
            assistiveText: translations.gasAssistiveText,
            onChange: calculationContext.setGHGCo2Gas,
            value: calculationContext.GreenhouseGasCo2Gas,
            suffix: translations.kCo2eLabel
        },
        {
            label: translations.oilLabel,
            assistiveText: translations.oilAssistiveText,
            onChange: calculationContext.setGHGCo2Oil,
            value: calculationContext.GreenhouseGasCo2Oil,
            suffix: translations.kCo2eLabel
        },
        {
            label: translations.districtHeatingLabel,
            assistiveText: translations.districtHeatingAssistiveText,
            onChange: calculationContext.setGHGDistrictHeating,
            value: calculationContext.GreenhouseGasDistrictHeating,
            suffix: translations.kCo2eLabel
        },
        {
            label: translations.districtCoolingLabel,
            assistiveText: translations.districtCoolingAssistiveText,
            onChange: calculationContext.setGHGDistrictCooling,
            value: calculationContext.GreenhouseGasDistrictCooling,
            suffix: translations.kCo2eLabel
        }
    ];

    return {
        calculationContext,
        percentageDivisionFields,
        costFields,
        productionEfficiencyFields,
        ghgFields
    };
};

export default useAdvancedSettings;
